// extracted by mini-css-extract-plugin
module.exports = {"holder":"WithAuthentication_holder__3vGQB","authContainer":"WithAuthentication_authContainer__2e7ky"};